import { render } from "./FileTypeComponent.vue?vue&type=template&id=c3df3408&scoped=true"
import script from "./FileTypeComponent.vue?vue&type=script&lang=js"
export * from "./FileTypeComponent.vue?vue&type=script&lang=js"

import "./FileTypeComponent.vue?vue&type=style&index=0&id=c3df3408&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3df3408"]])

export default __exports__